import Checkout from './Checkout.page';

export default Checkout;